import { render } from "./Carousel.vue?vue&type=template&id=0dd6bbf4&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=0dd6bbf4&scoped=true&lang=css"

import exportComponent from "/Users/john/Desktop/projects/vue_js_projects/portfolio-tailwind/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd6bbf4"]])

export default __exports__